// UrlQueryLoader.js
import { connect } from 'react-redux';
import loadUrlQuery from '../action/loadUrlQuery.js';
import UrlQueryLoader from '../component/UrlQueryLoader.jsx';

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    loadUrlQuery: ({ searchParams }) =>
      dispatch(loadUrlQuery({ searchParams })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UrlQueryLoader);
